import React from 'react';
import { attachmentService } from 'src/app/services';

const renderPreviewContent = (file: any, token: string | undefined) => {
  const type = file.mediaType || file.file?.type;

  const url = file.path
    ? attachmentService.getAttachmentUrl({ path: file.path, token })
    : URL.createObjectURL(file.file);

  switch (type) {
    case 'image/png':
    case 'image/jpeg':
    case 'image/jpg':
      return <img src={url} alt="preview" style={{ width: '100%' }} />;
    case 'text/plain':
    case 'application/json':
    case 'application/pdf':
      return <iframe src={url} title="preview" style={{ width: '100%', height: '600px' }} />;

    default:
      return <span>Preview not supported</span>;
  }
};

export default renderPreviewContent;
